module.exports = __webpack_public_path__ + "static/media/VISA.1487ac9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/VISA.svg
// module id = 81
// module chunks = 0